const SCHEDULED_MESSAGES = 'ScheduledMessages';

/** Base Fetch Actions */
export const FETCH_SCHEDULED_MESSAGES_REQUEST = `${SCHEDULED_MESSAGES}/FETCH_SCHEDULED_MESSAGES_REQUEST`;
export const FETCH_SCHEDULED_MESSAGES_RESPONSE = `${SCHEDULED_MESSAGES}/FETCH_SCHEDULED_MESSAGES_RESPONSE`;
export const FETCH_SCHEDULED_MESSAGES_ERROR = `${SCHEDULED_MESSAGES}/FETCH_SCHEDULED_MESSAGES_ERROR`;

export const DELETE_SCHEDULED_MESSAGES_REQUEST = `${SCHEDULED_MESSAGES}/DELETE_SCHEDULED_MESSAGES_REQUEST`;
export const DELETE_SCHEDULED_MESSAGES_RESPONSE = `${SCHEDULED_MESSAGES}/DELETE_SCHEDULED_MESSAGES_RESPONSE`;
export const DELETE_SCHEDULED_MESSAGES_ERROR = `${SCHEDULED_MESSAGES}/DELETE_SCHEDULED_MESSAGES_ERROR`;

export const DELETE_ALL_SCHEDULED_MESSAGES_REQUEST = `${SCHEDULED_MESSAGES}/DELETE_ALL_SCHEDULED_MESSAGES_REQUEST`;
export const DELETE_ALL_SCHEDULED_MESSAGES_RESPONSE = `${SCHEDULED_MESSAGES}/DELETE_ALL_SCHEDULED_MESSAGES_RESPONSE`;
export const DELETE_ALL_SCHEDULED_MESSAGES_ERROR = `${SCHEDULED_MESSAGES}/DELETE_ALL_SCHEDULED_MESSAGES_ERROR`;
